import { Component } from '@verndale/core';
import SimpleBar from 'simplebar';
import SlimSelect from 'slim-select';

class SlimSelectComponent extends Component {
  setupDefaults() {
    this.dom = {
      $el: this.el
    };

    this.init();
    this.simpleBar = null;
  } //setupDefaults

  init() {
    const { $el } = this.dom;
    new SlimSelect({
      select: $el,
      settings: {
        showSearch: true,
        searchFocus: true,
        valuesUseText: false,
        isMultiple: false
      },
      showContent: 'down',
      beforeOpen: this.beforeOpen.bind(this),
      events: {},
      onChange: data => this.setRegion(data)
    });
  } //init

  beforeOpen() {
    const { $el } = this.dom;

    try {
      if (this.simpleBar) {
        this.simpleBar.unMount();
      }

      const $slimSelect = $el.nextElementSibling;
      if ($slimSelect) {
        const $ssList = $slimSelect._$('.ss-list');
        if ($ssList) {
          this.simpleBar = new SimpleBar($ssList, { autoHide: false });
        }
      }
    } catch (error) {
      return;
    }
  } //beforeOpen

  setRegion(data){
    if (data.class && data.class === 'slim-select-location'){
      const selectedValue = data?.value || null;
      if (!selectedValue) return;

      window.location.href = `/location?CountryCode=${selectedValue}`;
      localStorage.selectedCountry = selectedValue;
      document.cookie = `CurrentSelectedCountryCode=${  selectedValue}`;
      return;
    }
  }

}

export default SlimSelectComponent;
